import { HashLink } from "react-router-hash-link";
import { TCourseThemes } from "../../types";
export interface ICourseThemesListProps {
  themes: TCourseThemes[];
}

export function CourseThemesList(props: ICourseThemesListProps) {
  const { themes } = props;
  const limitedThemes = themes.slice(0, 10);

  return (
    <ol className="MainPageTable">
      {limitedThemes.map((data) => (
        <li key={data.name}>
          <HashLink
            className="MainPageThemeLinks"
            to={`/theme#${data.shortName || data.name}`}
          >
            {data.shortName || data.name}
          </HashLink>
        </li>
      ))}
    </ol>
  );
}
